// extracted by mini-css-extract-plugin
export default {"Btn":"Global_Btn__Yiw6E","btnCancel":"Global_btnCancel__Zcrxs","btnConfirm":"Global_btnConfirm__ApQUu","BtnIcon":"Global_BtnIcon__FzI80"};